import React from "react";
import { INDUSTRIES } from "../../data/content";
import { Reveal, SectionHeading } from "../ui";

const Industries = () => (
  <section id="industries" className="section">
    <div className="container">
      <SectionHeading
        eyebrow="Industries"
        title="Built for every place people come and go."
        subtitle="A single infrastructure serving many sectors and operating models."
      />

      <div className="mt-16 grid gap-px overflow-hidden rounded-[2rem] border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {INDUSTRIES.map(({ icon: Icon, title, desc }, i) => (
          <Reveal key={title} delay={(i % 4) * 70} className="group bg-ink-950 p-8 transition hover:bg-ink-900">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/5 text-ink-200 ring-1 ring-inset ring-white/10 transition group-hover:bg-brand-600 group-hover:text-white group-hover:ring-brand-500">
              <Icon className="h-6 w-6" />
            </span>
            <h3 className="mt-6 font-display text-lg font-semibold text-white">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-400">{desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Industries;
